import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-facture',
  templateUrl: './brouillon-facture.component.html',
  styleUrls: ['./brouillon-facture.component.scss']
})
export class BrouillonFactureComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterFactureByStatus('Brouillon');
    }

}
